import { Signal } from '@fullstory/proto/fs/api/signalstudio';
import { combineReducers } from '@fullstory/redux-util/utils';
import { SignalActions } from './actions';
import { SignalRequestTypes } from './types';

const signals = (state: Signal[] = [], action: SignalActions): Signal[] => {
  switch (action.type) {
    case SignalRequestTypes.GetAllSignalSuccess:
      return action.data.signals;
    case SignalRequestTypes.UpsertSignalSuccess: {
      const signal = action.data.signal;
      if (signal == null || !signal.isCommitted) return state;

      const idx = state.findIndex(s => s.signalId === signal.signalId);
      return idx == -1
        ? [...state, signal]
        : [...state.slice(0, idx), signal, ...state.slice(idx + 1)];
    }
    case SignalRequestTypes.DeleteSignalSuccess: {
      return state.filter(s => s.signalId !== action.request.body?.signalId);
    }

    default:
      return state;
  }
};

type SignalsReducerState = {
  signals: ReturnType<typeof signals>;
};

export const signalsReducer = combineReducers<SignalsReducerState>({
  signals,
});

export type signalsReducer = ReturnType<typeof signalsReducer>;
